import { Marker} from 'mapbox-gl';
import type { Map as MapboxMap } from 'mapbox-gl';
import FeatureData from './FeatureData';

/**
 * Object to store place data.
 *
 * Place type:
 * - 'hotel'
 * - 'place' (city)
 */
class PlaceData extends FeatureData {    
    // Map Marker
    mapMarker?: Marker | null;
    
    // htmlElement lo declara FeatureData: redeclararlo aqui volveria a definir
    // la propiedad como undefined tras super() (useDefineForClassFields).

    /**
     * Some data properties.
     */
    iconClass?: string;
    
    /**
     * Set marker selected state.
     * 
     * @return
     *   True if marker is there and can be set.
     */
    setSelected(selected = true): boolean {
      const marker = this.getMapElement();
      if (!marker) {
        return false;
      }
      else if (selected) {
        marker.classList.add('selected');
        return true;
      }
      else {
        marker.classList.remove('selected');
        return true;
      }
    }
    
    /**
     * Create DOM Element
     *
     * Duplica la implementacion de FeatureData; se mantiene tal cual para no
     * alterar la cadena de prototipos en un cambio de tipado.
     */
    createElement(): HTMLElement {
        if (!this.htmlElement) {
          const el = document.createElement('div');
          // getMapItemId() puede devolver undefined. @see FeatureData.createElement
          el.id = String(this.getMapItemId());
          this.htmlElement = el;
        }
        
        return this.htmlElement;
    }
    
    /**
     * Gets HTML element from document
     *
     * @see createElement sobre la duplicacion.
     */
    getMapElement(refresh = true): HTMLElement | null | undefined {
        if (refresh || !this.htmlElement) {
          this.htmlElement = document.getElementById(String(this.getMapItemId()));
        }
        return this.htmlElement;
    }
    
    /**
     * Create MAP Marker.
     */
    createMapMarker(): Marker {
      if (!this.mapMarker) {
        const el = this.createElement();      
        // El sitio se asume con coordenadas, igual que antes de tipar: si
        // faltasen, setLngLat ya fallaba en tiempo de ejecucion.
        this.mapMarker = new Marker(el)
            .setLngLat(this.getGeoLocation()!);
      }
      return this.mapMarker;
    }
    
    /**
     * Add marker to Map.
     *
     * @return true if successful.
     */
    addToMap(mapObject: MapboxMap): boolean {
      const marker = this.createMapMarker();
      if (marker) {
        marker.addTo(mapObject);
        return true;
      }
      else {
        return false;
      }
    }
    
    /**
     * Remove marker from map.
     */
    removeMarker(): void {
      if (this.mapMarker) {
        this.mapMarker.remove();
        this.mapMarker = null;
      }
      this.removeElement();
    }
    
    /**
     * Remove HTML element.
     */
    removeElement(): void {
      if (this.htmlElement) {
        this.htmlElement.remove();
        this.htmlElement = null;
      }
    }
     
}

export default PlaceData;
